"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportedTableauFontFaces = exports.TableauSemiBoldFontFaceName = exports.TableauRegularFontFaceName = exports.TableauMediumFontFaceName = exports.TableauLightFontFaceName = exports.TableauBoldFontFaceName = exports.TableauBookFontFaceName = exports.TableauBoldFontFamilyName = exports.TableauSemiboldFontFamilyName = exports.TableauMediumFontFamilyName = exports.TableauRegularFontFamilyName = exports.TableauLightFontFamilyName = exports.TableauBookFontFamilyName = void 0;
exports.TableauBookFontFamilyName = 'Tableau Book';
exports.TableauLightFontFamilyName = 'Tableau Light';
exports.TableauRegularFontFamilyName = 'Tableau Regular';
exports.TableauMediumFontFamilyName = 'Tableau Medium';
exports.TableauSemiboldFontFamilyName = 'Tableau Semibold';
exports.TableauBoldFontFamilyName = 'Tableau Bold';
exports.TableauBookFontFaceName = 'Tableau Book';
exports.TableauBoldFontFaceName = 'Tableau Bold';
exports.TableauLightFontFaceName = 'Tableau Light';
exports.TableauMediumFontFaceName = 'Tableau Medium';
exports.TableauRegularFontFaceName = 'Tableau Regular';
exports.TableauSemiBoldFontFaceName = 'Tableau Semi Bold';
exports.SupportedTableauFontFaces = [
    exports.TableauBookFontFaceName,
    exports.TableauBoldFontFaceName,
    exports.TableauLightFontFaceName,
    exports.TableauMediumFontFaceName,
    exports.TableauRegularFontFaceName,
    exports.TableauSemiBoldFontFaceName,
];
//# sourceMappingURL=TableauBookFontNameConstants.js.map